import { useCallback, useContext } from "react";
import { ModalContext } from "src/modules/Modal";

/**
 * Shared hook for opening the status change confirmation modal from inline dropdowns.
 * @param submissionType - Label prefix for the modal (e.g. "" for inventory, undefined for CNC default)
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useOpenStatusChangeModal(submissionType?: string) {
  const { closeModal, openModal } = useContext(ModalContext);

  return useCallback(
    (
      value: string,
      pwsId: number,
      submissionPeriodId: number,
      pwsName: string,
      submissionId: number,
      refetch: () => Promise<any>
    ) =>
      openModal("changeCncStatusConfirmationModal", {
        closeModal: () => {
          closeModal();
        },
        value,
        pwsId,
        submissionPeriodId,
        pwsName,
        submissionCommunicationId: submissionId,
        submissionType,
        refetch,
      }),
    [openModal, closeModal, submissionType]
  );
}
